import { GlLineChart } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/charts.js?vue3';
import { merge } from 'lodash-es';
import dateFormat from '~/lib/dateformat';
import { __, sprintf } from '~/locale';
import commonChartOptions from './common_chart_options';
export default {
    name: 'BurnupChart',
    components: {
        GlLineChart
    },
    props: {
        startDate: {
            type: String,
            required: true
        },
        dueDate: {
            type: String,
            required: true
        },
        issuesSelected: {
            type: Boolean,
            required: false,
            default: true
        },
        burnupData: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            tooltip: {
                title: '',
                content: ''
            }
        };
    },
    computed: {
        scopeCount () {
            return this.transform('scopeCount');
        },
        completedCount () {
            return this.transform('completedCount');
        },
        scopeWeight () {
            return this.transform('scopeWeight');
        },
        completedWeight () {
            return this.transform('completedWeight');
        },
        dataSeries () {
            const series = [
                {
                    name: __('Total'),
                    data: this.issuesSelected ? this.scopeCount : this.scopeWeight
                },
                {
                    name: __('Completed'),
                    data: this.issuesSelected ? this.completedCount : this.completedWeight
                }
            ];
            return series;
        },
        yAxisTitle () {
            return __('Work items');
        },
        options () {
            return merge({}, commonChartOptions, {
                xAxis: {
                    min: this.startDate,
                    max: this.dueDate
                },
                yAxis: {
                    name: this.issuesSelected ? this.yAxisTitle : __('Weight')
                }
            });
        }
    },
    methods: {
        setChart (chart) {
            this.chart = chart;
        },
        // transform the object to a chart-friendly array of date + value
        transform (key) {
            return this.burnupData.map((val)=>[
                    val.date,
                    val[key]
                ]);
        },
        formatTooltipText (params) {
            const [total, completed] = params.seriesData;
            if (!total || !completed) {
                return;
            }
            this.tooltip.title = dateFormat(params.value, 'dd mmm yyyy');
            const count = total.value[1];
            const completedCount = completed.value[1];
            let totalText;
            let completedText;
            if (this.issuesSelected) {
                totalText = sprintf(__('%{count} total'), {
                    count
                });
                completedText = sprintf(__('%{completedCount} completed'), {
                    completedCount
                });
            } else {
                totalText = sprintf(__('%{count} total weight'), {
                    count
                });
                completedText = sprintf(__('%{completedCount} completed weight'), {
                    completedCount
                });
            }
            this.tooltip.total = totalText;
            this.tooltip.completed = completedText;
        }
    }
};
